import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDate, fmtDateTime } from "../serviceApi";

const TONE = { sent: "text-emerald-700 bg-emerald-50", blocked: "text-amber-800 bg-amber-50", suppressed: "text-slate-600 bg-slate-100", failed: "text-rose-700 bg-rose-50",
  skipped: "text-slate-600 bg-slate-100", cancelled: "text-slate-500 bg-slate-100", expired: "text-slate-500 bg-slate-100", sending: "text-blue-700 bg-blue-50" };

export function ScheduleLog({ scheduleId, refreshKey, overdueNote }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/service/recurring/schedules/${scheduleId}/log`).then(({ data }) => setD(data)).catch(() => setD(null)); }, [scheduleId, refreshKey]);
  if (!d) return null;
  return (
    <div className="space-y-3" data-testid="schedule-log">
      <div>
        <div className="text-[11px] font-bold uppercase tracking-wider text-slate-500 mb-1">Occurrence history</div>
        {!d.occurrences.length ? <div className="text-xs text-slate-400">No completed or skipped occurrences yet.</div> : d.occurrences.map((o) => (
          <div key={o.id} className="text-xs flex gap-2 py-0.5 flex-wrap" data-testid={`schedule-occurrence-${o.due_date}`}>
            <b className="text-slate-700 w-24">{fmtDate(o.due_date)}</b>
            <span className={o.status === "completed" ? "text-emerald-700 font-semibold" : o.status === "rescheduled" ? "text-orange-700 font-semibold" : "text-slate-500 font-semibold"} data-testid={`schedule-occurrence-status-${o.id}`}>
              {o.status === "rescheduled" ? `Rescheduled → ${fmtDate(o.new_due_date)}` : o.status === "completed" ? "Completed" : "Skipped"}
            </span>
            <span className="text-slate-400">{o.by?.name} · {fmtDateTime(o.at)}{o.note ? ` · ${o.note}` : ""}</span>
          </div>
        ))}
      </div>
      <div>
        <div className="text-[11px] font-bold uppercase tracking-wider text-slate-500 mb-1">Notification log</div>
        {!d.notifications.length ? <div className="text-xs text-slate-400">Nothing sent yet — reminders go out at 9:00 AM Eastern on the reminder date; {overdueNote}.</div> : (
          <div className="max-h-48 overflow-y-auto border border-slate-200 rounded-md">
            <table className="w-full text-xs">
              <thead className="bg-slate-50 text-slate-500"><tr><th className="text-left p-1.5">Recipient</th><th className="text-left p-1.5">Channel</th><th className="text-left p-1.5">For due</th><th className="text-left p-1.5">Planned / sent</th><th className="text-left p-1.5">State</th></tr></thead>
              <tbody>
                {d.notifications.map((n) => (
                  <tr key={n.id} className="border-t border-slate-100" data-testid="schedule-notification-row">
                    <td className="p-1.5 font-semibold text-slate-700">{n.contact_name}<div className="font-normal text-slate-400">{n.address}</div></td>
                    <td className="p-1.5 uppercase">{n.channel}{n.kind === "overdue" && <div className="text-rose-600 normal-case font-semibold">overdue notice</div>}</td>
                    <td className="p-1.5">{fmtDate(n.due_date)}</td>
                    <td className="p-1.5">{fmtDateTime(n.planned_at)}{n.sent_at && <div className="text-emerald-700">sent {fmtDateTime(n.sent_at)}</div>}</td>
                    <td className="p-1.5"><span className={`px-1.5 py-[1px] rounded font-bold uppercase text-[10px] ${TONE[n.state] || ""}`}>{n.state}</span>{n.retry_count > 0 && <span className="text-slate-400"> · {n.retry_count} retr{n.retry_count === 1 ? "y" : "ies"}</span>}{n.error && <div className="text-slate-500">{n.error}</div>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
